var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 106,
    viewBox: "0 0 236 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 26,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 26,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 26,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 26,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 26,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 52,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 52,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 52,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 52,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 52,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 78,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 78,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 78,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 78,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 78,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 104,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 104,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 104,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 104,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 104,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 26,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 26,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 26,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    y: 26,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 52,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 52,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 52,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 52,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    y: 52,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 78,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 78,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 78,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 78,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    y: 78,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 104,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 104,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 104,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 104,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    y: 104,
    width: 2,
    height: 2,
    fill: "#4D5258"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/Dots.6fd7a9b21a1dd742649069ac114fbd20.svg";
export { ForwardRef as ReactComponent };